export enum SubAccountStates {
  ACTIVE = 'ACTIVE',
  AWAITING_APPROVAL = 'AWAITING_APPROVAL',
  INACTIVE = 'INACTIVE',
}

export enum SubAccountTransitions {
  ACTIVATE = 'activate',
  REVIEW = 'review',
}
